module.exports = __webpack_public_path__ + "static/media/add-group.534a4e17.svg";